/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
/**
 * @module basic-styles/underline/underlineui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import underlineIcon from '../../theme/icons/underline.svg';
const UNDERLINE = 'underline';
/**
 * The underline UI feature. It introduces the Underline button.
 *
 * @extends module:core/plugin~Plugin
 */
export default class UnderlineUI extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        // Add bold button to feature components.
        editor.ui.componentFactory.add(UNDERLINE, locale => {
            const command = editor.commands.get(UNDERLINE);
            const view = new ButtonView(locale);
            view.set({
                label: t('u'),
                icon: underlineIcon,
                keystroke: 'CTRL+U',
                tooltip: true
            });
            view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
            // Execute command.
            this.listenTo(view, 'execute', () => editor.execute(UNDERLINE));
            return view;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ../ckeditor5-basic-styles/src/underline/underlineui.js
// module id = null
// module chunks = 